'use strict'

import 'core-js/stable/object/assign'
import 'regenerator-runtime/runtime'

import { getElData } from './utilities'

import barba from '@barba/core'

import audioPlayer from './controllers/audio-player'
import dialog from './controllers/dialog'
import form from './controllers/form'
import media from './controllers/media'
import menu from './controllers/menu'
import filter from './controllers/filter'
import transition from './controllers/transition'
import videoPlayer from './controllers/video-player'

const loadedClass = 'is-loaded'
const initializedControllers = new WeakSet()
let temporaryInitializedControllers = new WeakSet()
const controllers = {
  audioPlayer,
  dialog,
  form,
  media,
  filter,
  menu,
  transition,
  videoPlayer,
}

function init() {
  window.onload = function () {
    document.documentElement.classList.add(loadedClass)
  }

  // setInterval(function () {
  //   document.documentElement.querySelector('.MiniCart-count').textContent =
  //     Number(document.querySelector('.MiniCart-count').textContent) + 1
  // }, 1000)

  loadControllers()

  const skipContentButton = document.querySelector('.js-skipToContent')

  if (skipContentButton) {
    const hiddenClass = skipContentButton.getAttribute('data-class')
    skipContentButton.addEventListener('focus', function () {
      skipContentButton.classList.remove(hiddenClass)
    })

    skipContentButton.addEventListener('blur', function () {
      skipContentButton.classList.add(hiddenClass)
    })
  }

  if (
    !window.CSS &&
    window.CSS.supports('color', 'var(--color-dark)') === false
  ) {
    window.alert(
      'This website might work as intended in this browser, sorry. If this is something you think we should fix, contact me at info@annalinder.se and we’ll see what we can do :)'
    )
  }
}

function loadControllers(root, temporary) {
  root = root || document.documentElement
  temporary = temporary || false

  root.querySelectorAll('[data-controller]').forEach(function (el) {
    const data = getElData(el)
    const names = data.controller.split(', ')

    names.forEach(function (name) {
      if (controllers[name]) {
        const controller = new controllers[name](el, data)

        if (temporary) {
          temporaryInitializedControllers.add(controller)
        } else {
          initializedControllers.add(controller)
        }
      } else {
        throw new Error(`Controller ${name} does not exist!`)
      }
    })
  })
}

if (document.readyState !== 'loading') {
  init()
} else {
  document.addEventListener(
    'DOMContentLoaded',
    function () {
      init()
    },
    false
  )
}

barba.hooks.after(function (e) {
  temporaryInitializedControllers = new WeakSet()

  loadControllers(e.next.container, true)
})
